import {
	Gender,
	GetUserProfileQuery,
	NameValueMapFragment,
	UserFfpInfo,
	UserProfileFfpInfoFragment
} from '@websky/graphql';

type FfpInfo = Pick<UserFfpInfo, 'currentLevel' | 'cardNumber' | 'numberOfMiles'>;

export interface CurrentUser {
	id: string;
	userId: string;
	firstName: string;
	lastName: string;
	gender: Gender;
	ffpInfo: FfpInfo;
}

export const getValueByName = (values: NameValueMapFragment[], name: string): string => {
	if (!values.length) {
		return null;
	}

	return values.find(({ name: valueName }) => valueName === name)?.value ?? null;
};

export const getFfpInfo = (userFfpInfo?: UserProfileFfpInfoFragment): FfpInfo => {
	return {
		cardNumber: userFfpInfo?.cardNumber ?? null,
		currentLevel: userFfpInfo?.cardNumber ? userFfpInfo.currentLevel : null,
		numberOfMiles: userFfpInfo?.cardNumber ? userFfpInfo.numberOfMiles : 0
	};
};

export const currentUserFactory = (currentUser?: GetUserProfileQuery['CurrentUser']): CurrentUser => {
	if (!currentUser) {
		return null;
	}

	const findValueByName = getValueByName.bind(null, currentUser.userProfile?.values ?? []);

	return {
		id: currentUser.userProfile.id,
		userId: currentUser.userId,
		firstName: findValueByName('firstName'),
		lastName: findValueByName('lastName'),
		gender: findValueByName('gender') as Gender,
		ffpInfo: getFfpInfo(currentUser.userFfpInfo)
	};
};
